import {all} from 'redux-saga/effects';
import Appointments from './Appointments';
import Auth from './Auth';
import Customers from './Customers';
import Theme from './Theme';
import Cars from './Cars';
import Dashboards from './Dashboards';
import Parts from './Parts';
import Services from './Services';
import Tags from './Tags';
import Support from './Support';
import Vendors from './Vendors';
import Invoices from './Invoices';
import Notifications from './Notifications';
import Subscriptions from './Subscriptions';
import AccountSubscriptions from './AccountSubscriptions';

export default function* rootSaga(getState) {
	yield all([
		Appointments(),
		Auth(),
		Customers(),
		Theme(),
		Cars(),
		Dashboards(),
		Invoices(),
		Parts(),
		Services(),
		Tags(),
		Vendors(),
		Notifications(),
		Subscriptions(),
		AccountSubscriptions(),
		Support(),
	]);
}
